import React from "react";
import PropTypes from "prop-types";

/**
 * Div đóng vai trò button — tránh CSS reboot của Bootstrap trên thẻ <button>.
 * (Copy từ crm/payment-request/common.)
 */
const Clickable = React.forwardRef(function Clickable(
  { onClick, className = "", title, children, disabled = false, style, stopPropagation = false, ...rest },
  ref
) {
  const handle = (e) => {
    if (disabled) return;
    if (stopPropagation) e.stopPropagation();
    onClick?.(e);
  };
  return (
    <div
      ref={ref}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled || undefined}
      title={title}
      style={style}
      onClick={handle}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handle(e); }
      }}
      className={`tw-select-none ${disabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer"} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
});

Clickable.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  stopPropagation: PropTypes.bool,
};

export default Clickable;
